<div class="slide slide--best-time" [style.--slide-accent-color]="titleColor">
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi-block" *ngIf="!isEmpty && peakLabel">
			<typography variant="h/1" class="slide__kpi-value">
				{{ peakLabel }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					Peak engagement
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty">
		<div class="slide__chart-head">
			<typography variant="p/sm_medium" class="slide__chart-title">
				Engagement rate by day &amp; hour (UTC)
			</typography>
			<!-- The grid's own colour key; any other drawing labels itself. -->
			<div class="slide__legend" *ngIf="!chartSwitch.block">
				<typography variant="p/xs_medium" class="slide__legend-text">
					Low
				</typography>
				<span
					class="slide__legend-swatch slide__legend-swatch--1"
				></span>
				<span
					class="slide__legend-swatch slide__legend-swatch--2"
				></span>
				<span
					class="slide__legend-swatch slide__legend-swatch--3"
				></span>
				<span
					class="slide__legend-swatch slide__legend-swatch--4"
				></span>
				<typography variant="p/xs_medium" class="slide__legend-text">
					High
				</typography>
			</div>
		</div>

		<div class="slide__heatmap slide__chart-host">
			<svg
				*ngIf="!chartSwitch.block"
				class="slide__heatmap-svg"
				[attr.viewBox]="heatmapViewBox"
				preserveAspectRatio="xMidYMid meet"
			>
				<rect
					*ngFor="let cell of heatmapCells; trackBy: trackCell"
					class="slide__heatmap-cell"
					[attr.x]="cell.x"
					[attr.y]="cell.y"
					[attr.width]="cell.w"
					[attr.height]="cell.h"
					[attr.rx]="cellRx"
					[attr.fill]="accentColor"
					[attr.fill-opacity]="cell.opacity"
				></rect>
				<text
					*ngFor="let label of dayLabels; trackBy: trackLabel"
					class="slide__heatmap-axis slide__heatmap-axis--day"
					[attr.x]="label.x"
					[attr.y]="label.y"
				>
					{{ label.text }}
				</text>
				<text
					*ngFor="let label of hourLabels; trackBy: trackLabel"
					class="slide__heatmap-axis slide__heatmap-axis--hour"
					[attr.x]="label.x"
					[attr.y]="label.y"
				>
					{{ label.text }}
				</text>
			</svg>
			<app-report-chart-switch
				[state]="chartSwitch"
				[themeColor]="themeColor"
				[editorMode]="editorMode"
				(chartTypeChange)="chartTypeChange.emit($event)"
			></app-report-chart-switch>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">best time to post</div>
	</div>
</div>
